// auth.service.ts (updated to use localStorage for persistence across tab closes)
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { decrypt, encrypt } from './crypto.util';
import { Observable, map } from 'rxjs';
import {environment} from '../../../../environments/environment';
import { Router } from '@angular/router';
import { CommonsService } from '../commonservices/commons.service';

export interface User {
  id: number;
  UserName: string;
  u_type: 'A' | 'U';
  [key: string]: any;
}

@Injectable({ providedIn: 'root' })
export class AuthService {
  private USER_KEY = 'user';
  httpUrl: any;

  constructor(private http: HttpClient, private router: Router, private commons: CommonsService) {
    this.httpUrl = environment.apiUrl;
    //  this.loadUserFromStorage();
  }

  // private loadUserFromStorage(): void {
  //   const encryptedUser = sessionStorage.getItem(this.USER_KEY);
  //   if (encryptedUser) {
  //     const decryptedUser = decrypt(encryptedUser);
  //     if (decryptedUser) {
  //       this.commons.user = decryptedUser;
  //     } else {
  //        sessionStorage.removeItem(this.USER_KEY);
  //     }
  //   }
  // }
login(username: string, password: string, lang: string) {
    const rawPayload = {
    UserName: username,
    Password: password,
    lang: lang
  };

  return this.http
  .post<any>(
  `${this.httpUrl}/login/getLoginDTl`,
  { data: encrypt(rawPayload) },
  { withCredentials: true }
)
  //  .post<any>(`${this.httpUrl}/login/getLoginDTl`, {
  //     data: encrypt(rawPayload)
  //   })
    // .post<any>(`${this.httpUrl}/login/getLoginDTl`, {
    //   UserName: username,
    //   Password: password,
    //   lang: lang
    // })
    .pipe(
      map(res => {
        if (!res || !res.data  ) {
          throw new Error('Invalid credentials');
        }

        const decrypted = decrypt(res.data);
        if (!decrypted) throw new Error('Decryption failed');

        const user = decrypted.user ?? decrypted;
        
        //  sessionStorage.setItem('1000', res.token);
        //  this.commons.user = user;
          

        return user;
      })
    );
}
//   login(username: string, password: string, lang: string) {
//     return this.http
//       .post<any>(`${this.httpUrl}/login/getLoginDTl`, {
//         UserName: username,
//         Password: password,
//         lang: lang
//       })
//       .pipe(
//         map(res => {
//           if (!res || !res.data || !res.token) {
//             throw new Error('Invalid credentials');
//           }

//          sessionStorage.setItem('1000', res.token);
// sessionStorage.setItem('1005', res.data);

//           const decrypted = decrypt(res.data);
//           if (!decrypted) throw new Error('Decryption failed');

//            const encryptedUser = encrypt(decrypted.user);
//           if (encryptedUser) {
// sessionStorage.setItem(this.USER_KEY, encryptedUser);    
//       }

           
//           return decrypted.user;
//         })
//       );
//   }
logout(silent: boolean = false) {
  this.http.post(`${this.httpUrl}/login/logout`, {}, { withCredentials: true })
    .subscribe({
      next: () => {
        this.commons.user = null; // clear local user
        sessionStorage.clear();    // clear storage
        if (!silent) {
          this.router.navigate(['/login']); // only redirect if not silent
        }
      },
      error: (err) => {
        console.error('Logout failed', err);
        this.commons.user = null;
        sessionStorage.clear();
        if (!silent) {
          this.router.navigate(['/login']);
        }
      }
    });
}
  // logout() {
  //     // this.common.clearStorage();

  //   sessionStorage.clear();
  //   this.commons.user = null;  
  // }
getUser(): User | null {
  return this.commons.user || null;
}
  //  getUser(): User | null {
  //   if (this.commons.user) {
  //     return this.commons.user;
  //   }
  //   this.loadUserFromStorage();
  //   return this.commons.user || null;
  // }
}